module.exports = __webpack_public_path__ + "img/xiaomiStepEight.a49d5cba.png";